import { useAtomValue } from 'jotai/utils';
import { addonsSettingsAtom } from 'src/shared/settings/addons';

/**
 * Whether the Print Export addon is enabled for the current user.
 *
 * Print Export is a per-user addon that defaults to disabled and is granted
 * by an admin. The on-demand "Export for Print" action is only surfaced in
 * the assets UI (list rows, gallery cards, detail view) when the user has
 * the addon both added AND enabled.
 */
export function usePrintExportAvailable(): boolean {
  const addonsSettings = useAtomValue(addonsSettingsAtom);
  return Boolean(
    addonsSettings?.PRINT_EXPORT?.added && addonsSettings?.PRINT_EXPORT?.enabled,
  );
}
